var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 336,
    viewBox: "0 0 336 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4947_375931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    fill: "url(#paint0_radial_4947_375931)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4947_375931)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 47.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 47.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 71.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 95.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 119.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 143.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 167.5,
    stroke: "#E9EAEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4947_375931",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCircles);
export default __webpack_public_path__ + "static/media/background-circles.3b96656f60a4de8f93d607ff78add97b.svg";
export { ForwardRef as ReactComponent };